import Vue from 'vue'
import { isMobile } from './utils';
const App = () => import('./App.vue');
const AppH5 = () => import('./AppH5.vue');

Vue.config.productionTip = false
new Vue({
  render: h => h(isMobile()?AppH5:App),
}).$mount('#app')
